import { render, staticRenderFns } from "./show-packet.vue?vue&type=template&id=5a7d7ec4&scoped=true&"
import script from "./show-packet.vue?vue&type=script&lang=js&"
export * from "./show-packet.vue?vue&type=script&lang=js&"
import style0 from "./show-packet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./show-packet.vue?vue&type=style&index=1&id=5a7d7ec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d7ec4",
  null
  
)

component.options.__file = "show-packet.vue"
export default component.exports